<h2 mat-dialog-title class="text-lg font-bold mb-1">
  {{ isEditMode ? "Editar Contacto" : "Agregar Contacto" }}
</h2>
<mat-dialog-content class="modal-content">
  <form #createForm="ngForm" class="grid grid-cols-2 gap-4 p-5">
    <mat-form-field  class="col-span-1">
      <mat-label>Nombre(s)</mat-label>
      <input
        matInput
        [(ngModel)]="currentCreateCompanyContact.firstName"
        name="firstName"
        required
        (ngModelChange)="updateFullName()"
      />
    </mat-form-field>

    <mat-form-field  class="col-span-1">
      <mat-label>Apellido(s)</mat-label>
      <input
        matInput
        [(ngModel)]="currentCreateCompanyContact.lastName"
        name="lastName"
        (ngModelChange)="updateFullName()"
      />
    </mat-form-field>
    <mat-form-field  class="col-span-2">
      <mat-label>Nombre Completo</mat-label>
      <input
        matInput
        [value]="currentCreateCompanyContact.fullName"
        name="fullName"
        readonly
        required
      />
    </mat-form-field>

    <!-- <div class="col-span-2 mt-6">
      <h3>Correos de Contacto</h3>
      <table mat-table [dataSource]="emailsDataSource" class="w-full">
        <ng-container matColumnDef="email">
          <th mat-header-cell *matHeaderCellDef style="padding-right: 70px;">Email</th>
          <td mat-cell *matCellDef="let contact">{{ contact.email }}</td>
        </ng-container>
        <ng-container matColumnDef="isPrincipalEmail">
          <th mat-header-cell *matHeaderCellDef>Principal</th>
          <td mat-cell *matCellDef="let contact">
            <mat-slide-toggle [(ngModel)]="contact.isPrincipalEmail">
              {{ contact.isPrincipalEmail ? 'Sí' : 'No' }}
            </mat-slide-toggle>
          </td>
        </ng-container>
        <ng-container matColumnDef="addNew">
          <th mat-header-cell *matHeaderCellDef>
            <button mat-icon-button (click)="toggleEmailRow({ email: null })">
              <mat-icon>{{ expandedEmailIndex  === 'global' ? 'close' : 'add' }}</mat-icon>
            </button>
          </th>
          <td mat-cell *matCellDef=" let contact"></td>
        </ng-container>
    
        <tr mat-header-row *matHeaderRowDef="['email', 'isPrincipalEmail', 'addNew']"></tr>
        <tr mat-row *matRowDef="let row; columns: ['email', 'isPrincipalEmail', 'addNew'];"></tr>
      </table>
    
      <div *ngIf="expandedEmailIndex === 'global'" class="bg-gray-50 p-4">
        <div class="flex items-center space-x-4">
          <input [(ngModel)]="newEmail.email" name="email" style="max-width: 180px;" class="input" placeholder="Nuevo Correo" />
          <mat-slide-toggle [(ngModel)]="newEmail.isPrincipal" name="isPrincipalEmail" color="primary"></mat-slide-toggle>
          <button mat-icon-button color="primary" (click)="createEmail()">
            <mat-icon>check</mat-icon>
          </button>
        </div>
      </div>
    </div> -->

    <!-- <div class="col-span-2 mt-6">
      <h3>Correos de Contacto</h3>
      <table mat-table [dataSource]="emailsDataSource" class="w-full">
        
        <ng-container matColumnDef="email">
          <th mat-header-cell *matHeaderCellDef style="padding-right: 70px;">Email</th>
          <td mat-cell *matCellDef="let contact; let i = index">
            <ng-container *ngIf="editedEmailIndex !== i; else editEmail">
              {{ contact.email }}
            </ng-container>
            <ng-template #editEmail>
              <input [(ngModel)]="editedEmail.email" class="input" />
            </ng-template>
          </td>
        </ng-container>
    
        <ng-container matColumnDef="isPrincipalEmail">
          <th mat-header-cell *matHeaderCellDef>Principal</th>
          <td mat-cell *matCellDef="let contact; let i = index">
            <ng-container *ngIf="editedEmailIndex !== i; else editPrincipal">
              <mat-slide-toggle [checked]="contact.isPrincipalEmail" disabled>
                {{ contact.isPrincipalEmail ? 'Sí' : 'No' }}
              </mat-slide-toggle>
            </ng-container>
            <ng-template #editPrincipal>
              <mat-slide-toggle [(ngModel)]="editedEmail.isPrincipal" color="primary"></mat-slide-toggle>
            </ng-template>
          </td>
        </ng-container>
    
        <ng-container matColumnDef="actions">
          <th mat-header-cell *matHeaderCellDef>
            <button mat-icon-button (click)="toggleEmailRow()">
              <mat-icon>{{ expandedEmailIndex === 'global' ? 'close' : 'add' }}</mat-icon>
            </button>
          </th>
          <td mat-cell *matCellDef="let contact; let i = index">
            <ng-container *ngIf="editedEmailIndex !== i">
              <button mat-icon-button color="accent" (click)="editEmail(i, contact)">
                <mat-icon>edit</mat-icon>
              </button>
              <button mat-icon-button color="warn" (click)="removeEmail(i)">
                <mat-icon>delete</mat-icon>
              </button>
            </ng-container>
            <ng-container *ngIf="editedEmailIndex === i">
              <button mat-icon-button color="primary" (click)="saveEditedEmail(i)">
                <mat-icon>check</mat-icon>
              </button>
              <button mat-icon-button color="warn" (click)="cancelEdit()">
                <mat-icon>close</mat-icon>
              </button>
            </ng-container>
          </td>
        </ng-container>
    
        <tr mat-header-row *matHeaderRowDef="['email', 'isPrincipalEmail', 'actions']"></tr>
        <tr mat-row *matRowDef="let row; columns: ['email', 'isPrincipalEmail', 'actions'];"></tr>
      </table>
    
      <div *ngIf="expandedEmailIndex === 'global'" class="bg-gray-50 p-4">
        <div class="flex items-center space-x-4">
          <input [(ngModel)]="newEmail.email" name="email" style="max-width: 180px;" class="input" placeholder="Nuevo Correo" />
          <mat-slide-toggle [(ngModel)]="newEmail.isPrincipal" name="isPrincipalEmail" color="primary"></mat-slide-toggle>
          <button mat-icon-button color="primary" (click)="createEmail()">
            <mat-icon>check</mat-icon>
          </button>
        </div>
      </div>
    </div> -->
    
    <div class="col-span-2 mt-6">
      <h3>Correos de Contacto</h3>
      
      <table mat-table  [dataSource]="emailsDataSource" class="w-full">
        
        <!-- Columna Email -->
        <ng-container matColumnDef="email">
          <th mat-header-cell *matHeaderCellDef style="padding-right: 70px;">Email</th>
          <td mat-cell *matCellDef="let contact; let i = index">
            <ng-container *ngIf="editedEmailIndex !== i; else editEmail">
              {{ contact.email }}
            </ng-container>
            <ng-template #editEmail>
              <input [(ngModel)]="editedEmail.email" class="input" name="email"/>
            </ng-template>
          </td>
        </ng-container>
    
        <!-- Columna Principal -->
        <ng-container matColumnDef="isPrincipalEmail">
          <th mat-header-cell *matHeaderCellDef>Principal</th>
          <td mat-cell *matCellDef="let contact; let i = index">
            <ng-container *ngIf="editedEmailIndex !== i; else editPrincipal">
              <mat-slide-toggle [checked]="contact.isPrincipalEmail" disabled name="isPrincipalEmail">
                {{ contact.isPrincipalEmail ? 'Sí' : 'No' }}
              </mat-slide-toggle>
            </ng-container>
            <ng-template #editPrincipal>
              <mat-slide-toggle [(ngModel)]="editedEmail.isPrincipal" name="isPrincipalEmail" color="primary"></mat-slide-toggle>
            </ng-template>
          </td>
        </ng-container>
    
        <!-- Columna Acciones -->
        <ng-container matColumnDef="actions">
          <th mat-header-cell *matHeaderCellDef>
            <button mat-icon-button (click)="toggleEmailRow()">
              <mat-icon>{{ expandedEmailIndex === 'global' ? 'close' : 'add' }}</mat-icon>
            </button>
          </th>
          <td mat-cell *matCellDef="let contact; let i = index">
            <ng-container *ngIf="editedEmailIndex !== i">
              <button mat-icon-button color="accent" (click)="editEmail(i, contact)">
                <mat-icon>edit</mat-icon>
              </button>
              <button mat-icon-button color="warn" (click)="removeEmail(i)">
                <mat-icon>delete</mat-icon>
              </button>
            </ng-container>
            <ng-container *ngIf="editedEmailIndex === i">
              <button mat-icon-button color="primary" (click)="saveEditedEmail(i)">
                <mat-icon>check</mat-icon>
              </button>
              <button mat-icon-button color="warn" (click)="cancelEdit()">
                <mat-icon>close</mat-icon>
              </button>
            </ng-container>
          </td>
        </ng-container>
    
        <tr mat-header-row *matHeaderRowDef="['email', 'isPrincipalEmail', 'actions']"></tr>
        <tr mat-row *matRowDef="let row; columns: ['email', 'isPrincipalEmail', 'actions'];"></tr>
      </table>
    
      <!-- Inputs para agregar un nuevo correo -->
      <div *ngIf="expandedEmailIndex === 'global'" class="bg-gray-50 p-4">
        <div class="flex items-center space-x-4">
          <input [(ngModel)]="newEmail.email" name="email" style="max-width: 180px;" class="input" placeholder="Nuevo Correo" />
          <mat-slide-toggle [(ngModel)]="newEmail.isPrincipal" name="isPrincipalEmail" color="primary"></mat-slide-toggle>
          <button mat-icon-button color="primary" (click)="createEmail()">
            <mat-icon>check</mat-icon>
          </button>
        </div>
      </div>
    </div>
    
    <div class="col-span-2 mt-6">
      <h3>Teléfonos de Contacto</h3>
    
      <table mat-table [dataSource]="phonesDataSource" class="w-full">
        <!-- Columna Prefijo -->
        <ng-container matColumnDef="prefix">
          <th mat-header-cell *matHeaderCellDef style="max-width: 90px;">Prefijo</th>
          <td mat-cell *matCellDef="let contact; let i = index">
            <ng-container *ngIf="editedPhoneIndex !== i; else editPrefix">
              {{ contact.prefix }}
            </ng-container>
            <ng-template #editPrefix>
              <input [(ngModel)]="editedPhone.prefix" class="input" name="prefix" style="max-width: 90px;" />
            </ng-template>
          </td>
        </ng-container>
    
        <!-- Columna Teléfono -->
        <ng-container matColumnDef="phone">
          <th mat-header-cell *matHeaderCellDef style="max-width: 110px;">Teléfono</th>
          <td mat-cell *matCellDef="let contact; let i = index">
            <ng-container *ngIf="editedPhoneIndex !== i; else editPhone">
              {{ contact.phone }}
            </ng-container>
            <ng-template #editPhone>
              <input [(ngModel)]="editedPhone.phone" class="input" name="phone" style="max-width: 110px;" />
            </ng-template>
          </td>
        </ng-container>
    
        <!-- Columna Tipo -->
        <ng-container matColumnDef="type">
          <th mat-header-cell *matHeaderCellDef style="max-width: 110px;">Tipo</th>
          <td mat-cell *matCellDef="let contact; let i = index">
            <ng-container *ngIf="editedPhoneIndex !== i; else editType">
              {{ getPhoneTypeLabel(contact.typeId) }}
            </ng-container>
            <ng-template #editType>
              <mat-select [(ngModel)]="editedPhone.typeId" name="typeId">
                <mat-option *ngFor="let option of phoneTypeOptions" [value]="option._id">
                  {{ option.type }}
                </mat-option>
              </mat-select>
            </ng-template>
          </td>
        </ng-container>
    
        <!-- Columna Principal -->
        <ng-container matColumnDef="isPrincipalPhone">
          <th mat-header-cell *matHeaderCellDef>Principal</th>
          <td mat-cell *matCellDef="let contact; let i = index">
            <ng-container *ngIf="editedPhoneIndex !== i; else editPrincipal">
              <mat-slide-toggle [checked]="contact.isPrincipalPhone" disabled>
                {{ contact.isPrincipalPhone ? 'Sí' : 'No' }}
              </mat-slide-toggle>
            </ng-container>
            <ng-template #editPrincipal>
              <mat-slide-toggle [(ngModel)]="editedPhone.isPrincipal" name="isPrincipalPhone" color="primary"></mat-slide-toggle>
            </ng-template>
          </td>
        </ng-container>
    
        <!-- Columna Acciones -->
        <ng-container matColumnDef="actions">
          <th mat-header-cell *matHeaderCellDef>
            <button mat-icon-button (click)="togglePhoneRow()">
              <mat-icon>{{ expandedPhoneIndex === 'global' ? 'close' : 'add' }}</mat-icon>
            </button>
          </th>
          <td mat-cell *matCellDef="let contact; let i = index">
            <ng-container *ngIf="editedPhoneIndex !== i">
              <button mat-icon-button color="accent" (click)="editPhone(i, contact)">
                <mat-icon>edit</mat-icon>
              </button>
              <button mat-icon-button color="warn" (click)="removePhone(i)">
                <mat-icon>delete</mat-icon>
              </button>
            </ng-container>
            <ng-container *ngIf="editedPhoneIndex === i">
              <button mat-icon-button color="primary" (click)="saveEditedPhone(i)">
                <mat-icon>check</mat-icon>
              </button>
              <button mat-icon-button color="warn" (click)="cancelEditPhone()">
                <mat-icon>close</mat-icon>
              </button>
            </ng-container>
          </td>
        </ng-container>
    
        <tr mat-header-row *matHeaderRowDef="['prefix', 'phone', 'type', 'isPrincipalPhone', 'actions']"></tr>
        <tr mat-row *matRowDef="let row; columns: ['prefix', 'phone', 'type', 'isPrincipalPhone', 'actions'];"></tr>
      </table>
    
      <!-- Inputs para agregar un nuevo teléfono -->
      <div *ngIf="expandedPhoneIndex === 'global'" class="bg-gray-50 p-4">
        <div class="flex items-center space-x-4">
          <input [(ngModel)]="newPhone.prefix" name="prefix" style="max-width: 90px;" class="input" placeholder="Prefijo" />
          <input [(ngModel)]="newPhone.phone" name="phone" style="max-width: 110px;" class="input" placeholder="Nuevo Teléfono" />
          <mat-select [(ngModel)]="newPhone.typeId" name="typeId" placeholder="Selecciona un tipo">
            <mat-option *ngFor="let option of phoneTypeOptions" [value]="option._id">
              {{ option.type }}
            </mat-option>
          </mat-select>
          <mat-slide-toggle [(ngModel)]="newPhone.isPrincipal" name="isPrincipalPhone" color="primary"></mat-slide-toggle>
          <button mat-icon-button color="primary" (click)="createPhone()">
            <mat-icon>check</mat-icon>
          </button>
        </div>
      </div>
    </div>
    

    <!-- <div class="col-span-2 mt-6">
      <h3>Teléfonos de Contacto</h3>
      <table mat-table [dataSource]="phonesDataSource" class="w-full">
         
         <ng-container matColumnDef="prefix">
          <th mat-header-cell *matHeaderCellDef style="max-width: 90px;">Prefijo</th>
          <td mat-cell *matCellDef="let contact">{{ contact.prefix }}</td>
        </ng-container>
        
        <ng-container matColumnDef="phone">
          <th mat-header-cell *matHeaderCellDef style="max-width: 110px;">Teléfono</th>
          <td mat-cell *matCellDef="let contact">{{ contact.phone }}</td>
        </ng-container>

        <ng-container matColumnDef="type" >
          <th mat-header-cell *matHeaderCellDef style="max-width: 110px;">Tipo</th>

          
          <td mat-cell *matCellDef="let contact">{{ contact.type }}</td>
        </ng-container>
    
        <ng-container matColumnDef="isPrincipalPhone">
          <th mat-header-cell *matHeaderCellDef>Principal</th>
          <td mat-cell *matCellDef="let contact">
            <mat-slide-toggle [(ngModel)]="contact.isPrincipalPhone">
              {{ contact.isPrincipalPhone ? 'Sí' : 'No' }}
            </mat-slide-toggle>
          </td>
        </ng-container>
    
        <ng-container matColumnDef="addNew">
          <th mat-header-cell *matHeaderCellDef>
            <button mat-icon-button (click)="togglePhoneRow({ phone: null })">
              <mat-icon>{{ expandedPhoneIndex  === 'global' ? 'close' : 'add' }}</mat-icon>
            </button>
          </th>
          <td mat-cell *matCellDef></td>
        </ng-container>
    
        <tr mat-header-row *matHeaderRowDef="[ 'prefix','phone', 'type', 'isPrincipalPhone', 'addNew']"></tr>
        <tr mat-row *matRowDef="let row; columns: [ 'prefix','phone', 'isPrincipalPhone', 'addNew'];"></tr>
      </table>
      <div *ngIf="expandedPhoneIndex === 'global'" class="bg-gray-50 p-4">
        <div class="flex items-center space-x-4">
          <input [(ngModel)]="newPhone.prefix" name="prefix" style="max-width: 90px;" class="input" placeholder="Prefijo" />
          <input [(ngModel)]="newPhone.phone" name="phone" style="max-width: 110px;" class="input" placeholder="Nuevo Teléfono" />
          <mat-select
            [(ngModel)]="newPhone.typeId"
            name="typeId"
            required
            placeholder="Selecciona una opción"
          >
            <mat-option
              *ngFor="let option of phoneTypeOptions"
              [value]="option._id"
            >
              {{ option.type }}
            </mat-option>
          </mat-select>

          <mat-slide-toggle [(ngModel)]="newPhone.isPrincipal" name="isPrincipalPhone" color="primary"></mat-slide-toggle>
          <button mat-icon-button color="primary" (click)="createPhone()">
            <mat-icon>check</mat-icon>
          </button>
        </div>
      </div>
    </div> -->
    

    <div class="col-span-2">
      <label>Función de Contacto</label>
      <ng-select
        [(ngModel)]="currentCreateCompanyContact.functionId"
        [items]="contactFunctionList"
        bindLabel="name"
        bindValue="_id"
        [searchable]="true"
        placeholder="Seleccione una función de contacto"
        name="functionId"
        [appendTo]="'body'"
      >
      </ng-select>
    </div>

    <div class="col-span-1 flex items-center">
      <mat-slide-toggle
        [(ngModel)]="currentCreateCompanyContact.isPrincipal"
        name="isPrincipal"
        color="primary"
      >
        ¿Contacto Principal?
      </mat-slide-toggle>
    </div>
    <div class="col-span-1 flex items-center">
      <mat-slide-toggle
        [(ngModel)]="currentCreateCompanyContact.isOwnContact"
        name="isOwnContact"
        color="primary"
      >
        ¿Contacto Propio?
      </mat-slide-toggle>
    </div>
  </form>
</mat-dialog-content>
<mat-dialog-actions class="modal-actions flex">
  <button mat-button mat-dialog-close class="align-left">Cancelar</button>
  <button
    mat-raised-button
    color="primary"
    (click)="save()"
    [disabled]="!createForm.valid"
    class="justify-end"
  >
    {{ isEditMode ? "Actualizar" : "Guardar" }}
  </button>
</mat-dialog-actions>
